export const Default = () => ({

    benchmarkFiltersAnalysis: {
        date: {
            preset: "",
            customDateRange: []
        },
        surveys: [],
        raterGroups: []
    },

    fetchOrganizationConfigurationsApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    updateOrgConfigurationsApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },


    benchmarkFilters: {
        date: {
            preset: "",
            customDateRange: []
        },
        surveys: [],
        raterGroups: [
            'self',
            'manager',
            'direct report',
            'peer',
            "team member",
            "client",
            "cross-functional partner",
            'other'
        ]
    },


    fetchTotalFeedbackProvidersApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchTotalFeedbackProvidersStrengthAndDevApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },


    fetchCantAnswerResponseApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },
    fetchTopStrengthAndTopDevApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchRaterHeatmapApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchBenchmarkKpiTilesApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchSelfVsOthersApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchDistributionStripApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchRankDeltaApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchCommentsAndGistApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
        // Id of the most recently dispatched fetch (initial or dropdown-driven
        // scope re-fetch) — lets the reducer drop a response that resolves
        // after a newer request has already been issued.
        latestRequestId: null,
    },

    fetchOrgRaterGroupsApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchBenchmarkTaxonomyApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchSurveyLists: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    // Cascading Category / Sub-Category / Behavior drill-down for the Sample
    // Comments section. categoryKey/subKey are org-specific taxonomy node
    // values (from fetchBenchmarkTaxonomyApi), so they start empty and
    // SampleComments fills in the first category/sub-category once the
    // taxonomy loads.
    sampleCommentsFilters: {
        categoryKey: '',
        subKey: '',
        behaviorKey: 'all',
    },

    fetchBenchmarkAlignmentScoreApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    }

});